import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';

import { MotivoAfastamentoRequest, MotivoAfastamentoResponse } from './motivo-afastamento.model';

@Injectable({ providedIn: 'root' })
export class MotivoAfastamentoService extends BaseService {
    readonly PATH = environment.basePath + '/sistema/motivo-afastamento';

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    /** Lista os motivos de afastamento — `GET /sistema/motivo-afastamento`. */
    listar(): Observable<MotivoAfastamentoResponse[]> {
        return this.http.get<MotivoAfastamentoResponse[]>(this.PATH);
    }

    /** Cria/atualiza um motivo (upsert por `codigo`) e devolve a lista atualizada — `POST`. */
    salvar(request: MotivoAfastamentoRequest): Observable<MotivoAfastamentoResponse[]> {
        return this.http.post<MotivoAfastamentoResponse[]>(this.PATH, request);
    }

    /** Remove um motivo — `DELETE /sistema/motivo-afastamento/{codigo}`. */
    excluir(codigo: number): Observable<void> {
        return this.http.delete<void>(`${this.PATH}/${codigo}`);
    }
}
